module.exports = __webpack_public_path__ + "media/images/vectorsol1-57b4c35fdeabcf5382c6b1ff1bb8d073.png";